// extracted by mini-css-extract-plugin
export default {"container":"labelInput_container__muexc","nullStyle":"labelInput_nullStyle__OwyIP"};